<template>
  <v-card class="import-card">
    <!-- Ícono -->
    <div class="import-icon-wrap">
      <div class="import-icon-circle">
        <v-icon class="import-icon">upload_file</v-icon>
      </div>
    </div>

    <!-- Texto -->
    <div class="import-body">
      <h2 class="import-title">Importar Productos</h2>
      <p class="import-subtitle">
        Seleccione el laboratorio y adjunte el archivo CSV con los productos a
        importar.
      </p>
    </div>

    <!-- Formulario -->
    <div class="import-form">
      <v-form>
        <!-- Selector laboratorio -->
        <v-select
          :error-messages="errors.collect('laboratory')"
          :items="laboratories"
          data-vv-name="laboratory"
          label="Laboratorio"
          no-data-text="Datos no disponibles"
          required
          hide-details
          v-model="form.labId"
          v-validate="'required'"
          class="import-select"
        ></v-select>

        <!-- Zona de archivo -->
        <div
          class="file-zone"
          :class="{ 'file-zone--filled': fileName }"
          @click="pickFile"
        >
          <v-icon class="file-zone__icon">{{
            fileName ? 'description' : 'attach_file'
          }}</v-icon>
          <span class="file-zone__label">{{
            fileName || 'Seleccionar archivo CSV'
          }}</span>
          <input
            ref="fileInput"
            type="file"
            accept=".csv,.xls,.xlsx"
            style="display:none"
            @change="onFilePicked"
          />
        </div>
        <p v-if="fileError" class="file-error">El archivo es requerido</p>
      </v-form>
    </div>

    <!-- Acciones -->
    <div class="import-actions">
      <button class="import-btn import-btn--cancel" @click="$emit('close-csv')">
        Cancelar
      </button>
      <button
        class="import-btn import-btn--confirm"
        @click="uploadFile"
        :disabled="loading"
      >
        <span v-if="loading" class="import-spinner"></span>
        <span v-else>Importar</span>
      </button>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    laboratories: [],
    loading: false,
    fileName: '',
    fileError: false,
    form: {
      labId: '',
      files: null,
    },
  }),
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
  methods: {
    pickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(e) {
      const file = e.target.files[0]
      if (file) {
        this.form.files = file
        this.fileName = file.name
        this.fileError = false
      } else {
        this.form.files = null
        this.fileName = ''
      }
    },
    uploadFile() {
      this.$validator.validateAll().then(result => {
        if (!this.form.files) {
          this.fileError = true
          return
        }
        if (result && this.form.files) {
          this.loading = true
          this.$emit('loading-show')
          this.$store
            .dispatch('products/import', this.form)
            .then(response => {
              this.loading = false
              this.$emit('close-csv')
              setTimeout(() => {
                this.$emit('upload-ready', {
                  labId: this.form.labId,
                  file: response.data.file,
                })
              }, 3000)
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style scoped>
.import-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0;
}

.import-icon-wrap {
  display: flex;
  justify-content: center;
  padding: 28px 24px 0;
}

.import-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #eff6ff;
  border: 5px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.import-icon {
  color: #254f87 !important;
  font-size: 26px !important;
}

.import-body {
  padding: 16px 28px 4px;
  text-align: center;
}

.import-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
}

.import-subtitle {
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

.import-form {
  padding: 16px 28px 4px;
}

.import-select {
  margin-bottom: 16px;
}

/* Zona de archivo */
.file-zone {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1.5px dashed #cbd5e1;
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  transition: all 0.18s ease;
  background: #f8fafc;
  margin-top: 4px;
}

.file-zone:hover {
  border-color: #254f87;
  background: #eff6ff;
}

.file-zone--filled {
  border-color: #254f87;
  background: #eff6ff;
  border-style: solid;
}

.file-zone__icon {
  color: #254f87 !important;
  font-size: 20px !important;
  flex-shrink: 0;
}

.file-zone__label {
  font-size: 13px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-error {
  font-size: 12px;
  color: #e5252a;
  margin: 6px 0 0 4px;
}

/* Acciones */
.import-actions {
  padding: 16px 28px 24px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.import-btn {
  height: 42px;
  padding: 0 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
}

.import-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.import-btn--cancel {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.import-btn--cancel:hover:not(:disabled) {
  background: #e2e8f0;
}

.import-btn--confirm {
  background: #254f87;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(37, 79, 135, 0.25);
}

.import-btn--confirm:hover:not(:disabled) {
  background: #1e3f6f;
}

.import-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
